const literales_en = {
    Perfil: "Perfil",
    Usuarios: "Usuarios",
    CerrarSesion: "Cerrar sesión",
  };
  
  export default literales_en;
  